export default function (state, getters, rootState, rootGetters) {
    return rootState.settings.statements.opened;
}